<template>
    <div class="row">
        <div class="col-md-8">
            <div v-if="value.InValid.length > 0" class="table-responsive">
                <table class="table table-sm align-middle">
                    <thead>
                        <tr>
                            <th class="w-25">Başlangıç İli</th>
                            <th class="w-25">Başlangıç İlçesi</th>
                            <th class="w-25">Bitiş İli</th>
                            <th class="w-25">Bitiş İlçesi</th>
                            <th>Tamamla</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(data,index) in value.InValid">
                            <draft-price-edit-result-table-row :provinces="provinces" v-model="value.InValid[index]" :key="data.Id"></draft-price-edit-result-table-row>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div :class="value.InValid.length ? 'col-md-4' : 'col-md-12'" class="col-md-4">
            <div class="table-responsive">
                <table class="table table-sm align-middle">
                    <thead>
                        <tr>
                            <th class="w-25">Başlangıç İli</th>
                            <th class="w-25">Başlangıç İlçesi</th>
                            <th class="w-25">Bitiş İli</th>
                            <th class="w-25">Bitiş İlçesi</th>
                            <th class="text-nowrap">Müşteri Mesafe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="data in value.Valid">
                            <tr :key="data.Id">
                                <td>{{data.StartProvinceModel.Name}}</td>
                                <td>{{data.StartDistrictModel.Name}}</td>
                                <td>{{data.EndProvinceModel.Name}}</td>
                                <td>{{data.EndDistrictModel.Name}}</td>
                                <td class="text-right">{{data.CustomerKm}}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>         
        </div>
    </div>
</template>

<script>
import DraftPriceEditResultTableRow from '@/views/calculate-price/draft-price/components/DraftPriceEditResultTableRow'
import SystemDataApi from '@/api/system-data'
export default {
    components:{
        DraftPriceEditResultTableRow
    },
    props:{
        value:Object
    },
    data() {
        return {
            provinces: [],      
        }
    },
    mounted(){
        this.getProvinces()
    },
    methods:{
        getProvinces(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
    },
}
</script>

<style>

</style>